module.exports = __webpack_public_path__ + "img/zaiban.6fd68faa.png";